export default async function iziCanBeBound(productId) {
  if (!productId) {
    console.warn('[InPostPay] iziCanBeBound called without productId');
    return false;
  }

  const inpostPayWidget = document.querySelector(`.izi-widget-product[data-product-id="${productId}"]`);
  const formContainingWidget = inpostPayWidget ? inpostPayWidget.closest('form') : null;

  const formProductId = formContainingWidget || window.document.querySelector(`form[data-product_id="${productId}"]`);

  if (!formProductId) return true;

  const addToCartButton = formProductId.querySelector("button.single_add_to_cart_button");
  const addToCartButtonDisabledClass = formProductId.querySelector("button.single_add_to_cart_button.disabled");
  const buttonProductId = formProductId.querySelector(`a.add_to_cart_button[data-product_id="${productId}"]`);
  const productListingItem = formProductId.querySelector(`.post-${productId}`);
  const pewcItems = formProductId.querySelectorAll(`form.cart .pewc-item`);
  const wapfRequiredInputs = formProductId.querySelectorAll(`.wapf input[required]`);

  if (!buttonProductId && !formProductId && !productListingItem) return true;

  if (addToCartButton && addToCartButton.disabled || addToCartButtonDisabledClass) return false;

  if (wapfRequiredInputs.length > 0) {
    const isWapfRequiredInputFilled = Array.from(wapfRequiredInputs).every(input => input.value);
    if (!isWapfRequiredInputFilled) return false;
  }

  if (pewcItems.length > 0) {
    const pewcFormFieldsInputs = formProductId.querySelectorAll(`.pewc-item.required-field input[type="text"]`);
    const pewcFormFieldsSelects = formProductId.querySelectorAll(`.pewc-item select`);
    const pewcFormFieldsUploads = formProductId.querySelectorAll(`.pewc-item.required-field input.pewc_file_data`);

    if (pewcFormFieldsInputs.length > 0) {
      const isVariationSelected = Array.from(pewcFormFieldsInputs).every(field => field.value);
      if (!isVariationSelected) return false;
    }

    if (pewcFormFieldsSelects.length > 0) {
      const isVariationSelected = Array.from(pewcFormFieldsSelects).every(field => field.value);
      if (!isVariationSelected) return false;
    }

    if (pewcFormFieldsUploads.length > 0) {
      const isFileUploaded = Array.from(pewcFormFieldsUploads).every(field => field.value);
      if (!isFileUploaded) return false;
    }
  }

  if (formProductId) {
    const submitButton = formProductId.querySelector(`button[type="submit"]`);
    const isNotDisabled = !submitButton.classList.contains("disabled");
    if (!isNotDisabled) submitButton.click();
    return isNotDisabled;
  }

  if (buttonProductId) {
    const isSimple = !buttonProductId.classList.contains("product_type_variable");
    if (!isSimple) buttonProductId.click();
    return isSimple;
  }

  if (productListingItem) {
    const isInStock = !productListingItem.classList.contains("outofstock");
    if (!isInStock) formProductId.querySelector(`a[data-product_id="${productId}"]`).click();
    return isInStock;
  }
}
